import { render, staticRenderFns } from "./ShiftDetailDialog.vue?vue&type=template&id=0bcd8574"
import script from "./ShiftDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ShiftDetailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports